import { axiosB2 } from './axiosB2';
import { getB2Result, parseB2Envelope } from './b2Envelope';

/**
 * Create a Mailchimp list via B2 REST.
 * Proxy equivalent: POST /mailchimp/list (plain-text list name body).
 * B2 SOAP action: CreateMailChimpList
 *
 * @param {string} listName
 * @returns {Promise<string>} Created Mailchimp list id
 */
export function createMailChimpList(listName) {
    return axiosB2.post('CreateMailChimpList', { listName }).then(({ data }) => {
        const parsed = parseB2Envelope(data);
        const result = getB2Result(parsed);
        if (!result) {
            throw new Error('Empty Mailchimp list id');
        }
        return result;
    });
}
